import styled from "styled-components";

export const VoteButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22%;
  height: 32px;
  background: transparent;
  border: 4px solid #dcdcdc;
  font-size: 15px;
  color: #111;
  transition: box-shadow 0.2s linear, background-color 0.2s linear;
  margin: 10px;
  margin-left: 0;
  &:hover {
    background-color: #dcdcdc;
    color: #111;
  }
  &:active {
    box-shadow: inset 0px 5px 10px -5px rgba(0, 0, 0, 0.8);
  }
`;
export default VoteButton;